import React from 'react';

const ProfileSidebar = () => {
  return (
    <div className="">
      <div className="bg-white rounded-xl shadow-lg p-6 mb-6 border border-gray-100">
        {/* 头像和姓名部分 */}
        <div className="flex flex-col items-center mb-8">
          <div className="relative mb-4 rounded-full p-1 bg-gradient-to-r from-gray-100 to-gray-200">
            <img
              src="/images/people/yi_zeng.jpg"
              alt="Yi Zeng"
              className="w-32 h-32 object-cover rounded-full border-2 border-white"
              style={{objectPosition: 'center top'}}
            />
          </div>
          <h2 className="text-2xl font-bold text-gray-800">Yi Zeng</h2>
        </div>

        {/* 职位列表 */}
        <div className="space-y-3">
          {/* 职位 1 */}
          <div className="group transition-all duration-300 hover:-translate-x-0">
            <div className="bg-gray-0 rounded-t-lg p-5 mt-5 hover:shadow transition-all duration-300">
              <div className="mb-2">
                <div className="font-semibold text-[#c00000]">Founding Dean</div>
              </div>
              <div className="text-gray-700 text-sm">
                <a href="https://beijing-aisi.ac.cn/" target="_self" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-900 transition-colors duration-200">Beijing Institute of AI Safety and Governance</a><br/>
              </div>
            </div>
          </div>

          {/* 职位 2 */}
          <div className="group transition-all duration-300 hover:-translate-x-0">
            <div className="bg-gray-0 rounded-t-lg p-5 mt-5 hover:shadow transition-all duration-300">
              <div className="mb-2">
                <div className="font-semibold text-[#c00000]">Wu Yuzhang Chair Professor</div>
              </div>
              <div className="text-gray-700 text-sm">
                <a href="http://ai.ruc.edu.cn/english/FACULTYn/YiZeng/index.htm" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-900 transition-colors duration-200">Gaoling School of AI, Renmin University of China</a><br/>
              </div>
            </div>
          </div>

          {/* 职位 3 */}
          <div className="group transition-all duration-300 hover:-translate-x-0">
            <div className="bg-gray-0 rounded-t-lg p-5 mt-5 hover:shadow transition-all duration-300">
              <div className="mb-2">
                <div className="font-semibold text-[#c00000]">Founding Director</div>
              </div>
              <div className="text-gray-700 text-sm">
                <a href="https://beijing.ai-safety-and-superalignment.cn/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-900 transition-colors duration-200">Beijing Key Laboratory of Safe AI and Superalignment</a><br/>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 mb-5 text-gray-500">
          <div className="flex justify-evenly items-center">
            <a className="sm-twitter" href="mailto:yi.zeng@beijing-aisi.ac.cn" target="_blank">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-envelope-open-fill sm-icon" viewBox="0 0 16 16">
                <path
                  d="M8.941.435a2 2 0 0 0-1.882 0l-6 3.2A2 2 0 0 0 0 5.4v.313l6.709 3.933L8 8.928l1.291.717L16 5.715V5.4a2 2 0 0 0-1.059-1.765l-6-3.2zM16 6.873l-5.693 3.337L16 13.372v-6.5zm-.059 7.611L8 10.072.059 14.484A2 2 0 0 0 2 16h12a2 2 0 0 0 1.941-1.516zM0 13.373l5.693-3.163L0 6.873v6.5z"/>
              </svg>
            </a>
            <a className="sm-twitter" href="https://twitter.com/yi_zeng" target="_blank">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-twitter sm-icon" viewBox="0 0 16 16">
                <path
                  d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z"/>
              </svg>
            </a>
            <a className="sm-twitter" href="http://www.facebook.com/people/Yi-Zeng/1208484135#!/profile.php?id=1208484135" target="_blank">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-facebook sm-icon" viewBox="0 0 16 16">
                <path
                  d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"/>
              </svg>
            </a>
            <a className="sm-twitter" href="https://www.linkedin.com/in/yi-zeng-097757122/" target="_blank">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-linkedin sm-icon" viewBox="0 0 16 16">
                <path
                  d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"/>
              </svg>
            </a>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ProfileSidebar;